import { Component } from '@angular/core';

/**
 * Icono pastillas ATB (SVG; color `var(--primary-color)` por defecto, verde si `.atb-positive`; tamaño máx. 1rem).
 */
@Component({
  selector: 'afoone-atb-pills-icon',
  template: `
    <svg
      class="atb-pills-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 122.88 98.24"
      aria-hidden="true"
      focusable="false"
    >
      <g class="atb-pills-graphic" fill="currentColor">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M57.1,70.14c5.17-8.96,16.63-12.03,25.59-6.86c2.44,1.41,4.44,3.28,5.96,5.44L56.2,87.09 C53.86,81.81,53.99,75.52,57.1,70.14L57.1,70.14z M33.79,9.22c5.08-8.8,16.44-11.84,25.24-6.76l0,0 c8.8,5.08,11.84,16.44,6.76,25.24c-10.5,18.19-20.98,36.2-31.48,54.39l0,0c-2.53,4.38-6.62,7.33-11.17,8.55 c-4.55,1.22-9.57,0.71-13.95-1.82h0c-4.38-2.53-7.33-6.62-8.55-11.17c-1.22-4.55-0.71-9.57,1.82-13.95v0 C12.96,45.49,23.27,27.44,33.79,9.22L33.79,9.22z M87.92,21.34c5.17-8.96,16.63-12.03,25.59-6.86c2.44,1.41,4.44,3.28,5.96,5.44 L87.01,38.3C84.68,33.01,84.81,26.73,87.92,21.34L87.92,21.34z M121,22.54c2.61,5.4,2.59,11.95-0.64,17.54 c-5.17,8.96-16.63,12.03-25.59,6.86c-2.64-1.52-4.76-3.59-6.32-5.97L121,22.54L121,22.54z M47.44,55.3L19.08,38.93L4.2,64.71l0,0 c-2.25,3.9-2.7,8.36-1.61,12.42c1.09,4.06,3.71,7.7,7.6,9.95l0,0c3.9,2.25,8.36,2.7,12.42,1.61c4.05-1.09,7.7-3.71,9.95-7.61l0,0 L47.44,55.3L47.44,55.3z M90.18,71.34c2.61,5.4,2.59,11.95-0.64,17.54c-5.17,8.96-16.63,12.03-25.59,6.86 c-2.64-1.52-4.76-3.59-6.32-5.97L90.18,71.34L90.18,71.34z"
        />
      </g>
    </svg>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        vertical-align: middle;
        line-height: 0;
        color: var(--primary-color, #cf4b00);
      }
      :host(.atb-positive) {
        color: var(--green-600, #16a34a);
      }
      .atb-pills-svg {
        display: block;
        height: 1rem;
        width: auto;
        max-height: 1rem;
        aspect-ratio: 122.88 / 98.24;
        overflow: visible;
        vector-effect: non-scaling-stroke;
      }
      .atb-pills-graphic {
        stroke: currentColor;
        stroke-width: 1px;
        paint-order: stroke fill;
        stroke-linejoin: round;
        stroke-linecap: round;
      }
    `,
  ],
})
export class AtbPillsIconComponent {}
